import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const headerWrapper = css`
  padding: ${spacing.sm}px;
  border-left: 3px solid transparent;

  &[aria-checked='mixed'] {
    border-left-color: ${palette.greyBase};
  }

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      border-left: none;
      padding: ${spacing.sm}px 0;
    `,
  )};

  h4 {
    margin: 0;
    font-size: 16px;
    line-height: 28px;
    font-family: var(${themeVariables.typography.body.fontFamily});
    font-weight: 600;
    text-transform: capitalize;
  }

  &[aria-hidden='true'] > h4 {
    color: color-mix(in srgb, ${palette.greyBase} 30%, white);
  }

  h5 {
    margin: 0;
    ${responsiveText.BODY.SM};
    font-family: var(${themeVariables.typography.body.fontFamily});
    font-weight: var(${themeVariables.typography.body.fontWeight});
    color: ${palette.greyBase};
  }
`;

export const count = css`
  ${responsiveText.BODY.MD};
  font-weight: 400;
  color: ${palette.greyBase};
  padding-left: ${spacing.base}px;
`;
